import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import { hasPermission, apiGet, getAgentLanguage } from '../../store/apiWrapper';
import { addConsentToStorage, hasConsentInStorage } from '../repi/repiUtils';
import { isNullOrUndefined, capitalize, getRepiSetting } from '../../store/storeFunctions';

export const generate = function (entityId, reports, includeQuickReport = false, addNegativeInfo = false, subjectType = 0) {
    let links = [];

    const repiLink = reports.REPI ? getRepiLink(entityId, subjectType) : null;
    hasPermission(null, "SimpleReport") && includeQuickReport && (!reports.AR) &&
        links.push({ url: `/report/quick/${entityId}`, type: 'QR', translationKey: 'Links.QR', primaryAttr: reports.primaryAttr, tabOrder: 0 });
    hasPermission(null, "SimpleReport") && includeQuickReport && reports.AR &&
        links.push({ url: `/report/quick-address/${entityId}`, type: 'AR', translationKey: 'Links.QR', primaryAttr: reports.primaryAttr, tabOrder: 0 });
    czSk(reports.primaryAttr, "FlexiReport", "GeneralReport") && reports.GR &&
        links.push({ url: `/report/global/${entityId}`, type: 'GR', translationKey: 'Links.GR', primaryAttr: reports.primaryAttr, tabOrder: 2 });
    czSk(reports.primaryAttr, "ShortReportCZ", "ShortReportSK") && reports.SR &&
        links.push({ url: `/report/short/${entityId}`, type: 'SR', translationKey: 'Links.SR', primaryAttr: reports.primaryAttr, tabOrder: 1 });
    hasPermission(null, "ReportFO") && reports.RP &&
        links.push({ url: `/report/natural/${entityId}`, type: 'RP', translationKey: 'Links.RP', primaryAttr: reports.primaryAttr, tabOrder: 4 });
    !isNullOrUndefined(repiLink) &&
        links.push({ url: repiLink, type: 'REPI', translationKey: 'Links.Repi', primaryAttr: reports.primaryAttr, tabOrder: 14 })
    hasPermission(null, 'RelationsReport') && (reports.RD || reports.AR) &&
        links.push({ url: `/relation-chart/${entityId}`, type: 'RD', translationKey: 'Links.RD', primaryAttr: reports.primaryAttr, tabOrder: 5 });
    hasPermission(null, 'EconomicGroupView') && reports.EG &&
        links.push({ url: `/report/economic-group/${entityId}`, type: 'EG', translationKey: 'Links.EG', primaryAttr: reports.primaryAttr, tabOrder: 6 });
    hasPermission(null, "CadastreSkReport") && reports.PS &&
        links.push({ url: `/search/property-sk/report?searchBy=3&entityId=${entityId}`, type: 'PS', translationKey: 'Links.PS', primaryAttr: reports.primaryAttr, tabOrder: 10 });
    hasPermission(null, "BusinessBulletin") && reports.BB &&
        links.push({ url: `/search/businessBulletin/results?entityId=${entityId}`, type: 'BB', translationKey: 'Links.BB', primaryAttr: reports.primaryAttr, tabOrder: 9 });
    hasPermission(null, "MonitoraAnnotation") && reports.SR &&
        links.push({ url: `/report/monitora/${entityId}`, type: 'MR', translationKey: 'Links.MR', primaryAttr: reports.primaryAttr, tabOrder: 7 });
    hasPermission(null, "CompanyAMLInfo") && reports.SR &&
        links.push({ url: `/search/aml/results/company/report/${entityId}`, type: 'AML', translationKey: 'Links.AML', primaryAttr: reports.primaryAttr, tabOrder: 11 });
    hasPermission(null, "RegisteredVehiclesFullPermission") && reports.VR &&
        links.push({ url: `/report/vehicle/${entityId}`, type: 'VR', translationKey: 'Links.VR', primaryAttr: reports.primaryAttr, tabOrder: 8 });
    hasPermission(null, "ReliabilityReport") && reports.RR &&
        links.push({ url: `/report/reliability/${entityId}`, type: 'DOZ', translationKey: 'Links.DOZ', primaryAttr: reports.primaryAttr, tabOrder: 12 });
    addNegativeInfo && reports.NI &&
        links.push({ url: `/report/warnings/${entityId}`, type: 'NI', translationKey: 'Links.NI', primaryAttr: reports.primaryAttr, tabOrder: 13, renderNegativeInfo: true });
    hasPermission(null, "MirriReport") && reports.MI &&
        links.push({ url: `/report/mirri/${entityId}`, type: 'MI', translationKey: 'Links.MI', primaryAttr: reports.primaryAttr, tabOrder: 14 });
    czSk(reports.primaryAttr, "ESGReportCZ", "ESGReportSK") && reports.ESG &&
        links.push({ url: `/report/esg/${entityId}`, type: 'ESG', translationKey: 'Links.ESG', primaryAttr: reports.primaryAttr, tabOrder: 3 });

    return links;
};

const getRepiLink = function (entityId, subjectType) {
    if (!hasPermission(null, "MainRepi"))
        return null;

    const isSk = getAgentLanguage() === "sk-SK";

    if (subjectType === 1 && !hasPermission(null, "REPIPO"))
        return null;
    if (subjectType === 3 && !hasPermission(null, "REPIFOP"))
        return null;

    let repiLink = null;
    if (hasPermission(null, isSk ? "REPISkCreditReportInvoicesPlus" : "REPICreditReportInvoicesPlus"))
        repiLink = `/repi/report/InvoicesPlus/${entityId}`;
    else if (hasPermission(null, isSk ? "REPISkCreditReportInvoicesMinus" : "REPICreditReportInvoicesMinus"))
        repiLink = `/repi/report/InvoicesMinus/${entityId}`;
    else if (hasPermission(null, isSk ? "REPISkCreditReportPlus" : "REPICreditReportPlus") && hasPermission(null, "REPIItrade"))
        repiLink = `/repi/report/CreditPlus/${entityId}`;
    else if (hasPermission(null, isSk ? "REPISkCreditReportMinus" : "REPICreditReportMinus") && hasPermission(null, "REPIItrade"))
        repiLink = `/repi/report/CreditMinus/${entityId}`;
    else if (hasPermission(null, isSk ? "REPISkCreditReportPoolPlus" : "REPICreditReportPoolPlus") && hasPermission(null, "REPIItrade"))
        repiLink = `/repi/report/PoolPlus/${entityId}`;
    else if (hasPermission(null, isSk ? "REPISkCreditReportPoolMinus" : "REPICreditReportPoolMinus") && hasPermission(null, "REPIItrade"))
        repiLink = `/repi/report/PoolMinus/${entityId}`;
    else if (hasPermission(null, isSk ? "REPISkCreditReportPlusSubject" : "REPICreditReportPlusSubject") && hasPermission(null, "REPIItrade"))
        repiLink = `/repi/report/SubjectPlus/${entityId}`;

    return repiLink
}

export const redirectToRepi = function (link, openNewWindow, props = null) {
    const shared = getRepiSetting("allowSharing", false);
    const linkParts = link.split("/").filter(f => !isNullOrUndefined(f) && f.length > 0);
    const maxIdx = linkParts.length - 1;
    const entityId = parseInt(linkParts[maxIdx]);
    const reportType = linkParts[maxIdx - 1];
    const errorUrl = '/repi/search';
    apiGet(`${window.babylonApiUrl}/api/repi/${entityId}/repi-subject-id`, null,
        (s) => {
            if (!isNullOrUndefined(s.data)) {
                if (s.data.type === 2 && reportType.includes("Plus") && !hasConsentInStorage(s.data.id)) {
                    props.showPopup("repiConsentPopup", {
                        open: true,
                        close: () => {
                            props.hidePopup();
                            if (reportType === "SubjectPlus")
                                return;
                            const minusReport = reportType.replace("Plus", "Minus");
                            if (openNewWindow || isNullOrUndefined(props.history))
                                window.open(`/repi/report/${minusReport}/${s.data.id}?sharedRegistry=${shared}&source=cribis`, "_blank");
                            else
                                props.history.push(`/repi/report/${minusReport}/${s.data.id}?sharedRegistry=${shared}&source=cribis`);
                        },
                        onConfirm: () => {
                            props.hidePopup();
                            addConsentToStorage(s.data.id);
                            if (openNewWindow || isNullOrUndefined(props.history))
                                window.open(`/repi/report/${reportType}/${s.data.id}?sharedRegistry=${shared}&source=cribis`, "_blank");
                            else
                                props.history.push(`/repi/report/${reportType}/${s.data.id}?sharedRegistry=${shared}&source=cribis`);
                        },
                        reportName: props.translate(`Repi.Report.${capitalize(reportType)}`)
                    })
                }
                else {
                    if (openNewWindow || isNullOrUndefined(props.history))
                        window.open(`/repi/report/${reportType}/${s.data.id}?sharedRegistry=${shared}&source=cribis`, "_blank");
                    else
                        props.history.push(`/repi/report/${reportType}/${s.data.id}?sharedRegistry=${shared}&source=cribis`);
                }
            }
            else {
                if (openNewWindow || isNullOrUndefined(props.history))
                    window.open(`${errorUrl}`, "_blank");
                else
                    props.history.push(`${errorUrl}`);
            }
        },
        (_) => {
            if (openNewWindow || isNullOrUndefined(props.history))
                window.open(`${errorUrl}`, "_blank");
            else
                props.history.push(`${errorUrl}`);
        }
    );
}

export const renderLink = function (url, translationKey, openNewWindow, primaryAttr, includeTooltips, translate, extraClass,
    useShort = false, entityIdNegativeInfo = null, type = null, props = null
) {
    var canAccess = czSk(primaryAttr, "AccessCzechData", "AccessSlovakData");

    let translation = translate(`${translationKey}.Description`);
    if (localStorage.getItem('locales_report_buttons_format') === 'short') {
        translation = translate(`${translationKey}.ExtraShort`);
    } else if (useShort) {
        translation = translate(`${translationKey}.Short`);
    }

    if (type === 'REPI') {
        return (
            <Link key={translationKey} to="#"
                className={classnames(`${canAccess ? 'report-link' : 'report-link disabled'} ${extraClass || ''}`.trim(),
                    { 'is-square': localStorage.locales_button_style === 'square' })}
                title={includeTooltips ? translate(`${translationKey}.Description`).replace(/<\/?[^>]+(>|$)/g, "") : ""}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    redirectToRepi(url, openNewWindow || e.button === 1, props);
                    return false;
                }}
                onAuxClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    redirectToRepi(url, openNewWindow || e.button === 1, props);
                    return false;
                }}
            >
                {ReactHtmlParser(translation)}
            </Link>
        )
    }

    if (!canAccess)
        return <div>{translate(`${translationKey}.Description`, null, { renderInnerHtml: true })}</div>;

    return entityIdNegativeInfo !== null
        ? <Link key={translationKey} to="#"
            className={classnames(`report-link ${extraClass || ''}`.trim(), { 'is-square': localStorage.locales_button_style === 'square' })}
            title={includeTooltips ? translate(`${translationKey}.Description`).replace(/<\/?[^>]+(>|$)/g, "") : ""}
            onClick={(e) => {
                e.preventDefault();
                window.open(`/warnings/${entityIdNegativeInfo}`, "_blank", "resizable=yes, scrollbars=yes, titlebar=yes, width=800, height=900, top=10, left=10");
                return false;
            }}
        >{ReactHtmlParser(translation)}</Link>
        : <Link key={translationKey} to={url}
            className={classnames(`report-link ${extraClass || ''}`.trim(), { 'is-square': localStorage.locales_button_style === 'square' })}
            title={includeTooltips ? translate(`${translationKey}.Description`).replace(/<\/?[^>]+(>|$)/g, "") : ""}
            target={openNewWindow ? "_blank" : null}
        >{ReactHtmlParser(translation)}</Link>
}

export const czSk = function (primaryAttr, czRole, skRole) {
    var canAccess = false;
    switch (primaryAttr) {
        case 1: canAccess = hasPermission(null, czRole); break;
        case 2: canAccess = hasPermission(null, skRole); break;
        case 3: canAccess = hasPermission(null, czRole) || hasPermission(null, skRole); break;
        default: canAccess = false; break;
    }
    return canAccess;
}

export const isMobileHiddenReport = type => type === 'EG' || type === 'AR';
